import { memo } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import type { CrmMessageBatchHistoryItem } from "../types";

export interface CrmMessageBatchHistoryPanelProps {
  summarizedBatchHistory: CrmMessageBatchHistoryItem[];
  hasHistory: boolean;
  onViewFullHistory: () => void;
}

const CrmMessageBatchHistoryPanel = memo(
  ({
    summarizedBatchHistory,
    hasHistory,
    onViewFullHistory,
  }: CrmMessageBatchHistoryPanelProps) => {
    return (
      <Box>
        <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 0.75 }}>
          Histórico de mensagens enviadas
        </Typography>
        {!hasHistory ? (
          <Typography variant="body2" color="text.secondary">
            Nenhum envio encontrado até o momento.
          </Typography>
        ) : (
          <>
            <List dense disablePadding>
              {summarizedBatchHistory.map((item) => (
                <ListItem
                  key={item.id}
                  sx={{
                    px: 0,
                    py: 0.75,
                    alignItems: "flex-start",
                    borderBottom: "1px dashed",
                    borderColor: "divider",
                    "&:last-of-type": { borderBottom: "none" },
                  }}
                >
                  <ListItemText
                    primary={
                      <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Typography variant="body2" color="text.primary">
                          {item.dateLabel}
                        </Typography>
                        <Chip
                          size="small"
                          label={item.statusLabel}
                          color={
                            item.status === "completed"
                              ? "success"
                              : item.status === "inProgress"
                                ? "warning"
                                : item.status === "failed"
                                  ? "error"
                                  : "default"
                          }
                          sx={{ minWidth: 110 }}
                        />
                      </Stack>
                    }
                    secondary={
                      <Typography variant="caption" color="text.secondary">
                        Enviadas: {item.sentCount.toLocaleString("pt-BR")}
                      </Typography>
                    }
                  />
                </ListItem>
              ))}
            </List>
            <Button
              type="button"
              size="small"
              onClick={onViewFullHistory}
              sx={{ mt: 0.75, textTransform: "none", px: 0 }}
            >
              Ver histórico completo
            </Button>
          </>
        )}
      </Box>
    );
  },
);

CrmMessageBatchHistoryPanel.displayName = "CrmMessageBatchHistoryPanel";

export default CrmMessageBatchHistoryPanel;
